import { sendEmail, sendText } from 'apps/sender/apis/paycodes';

export type Options = {
  paycode: string,
  email: string,
  phone: string,
  cb: any,
};

export function sendMessageEmail(options: Options) {
  const { paycode, email, cb } = options;

  sendEmail(paycode, { to: email })
    .then((result) => {
      if (cb) {
        if (result.hasOwnProperty('error_code') && result.error_code === 0) {
          cb({
            ...result,
            isError: false,
            message: 'An email was sent successfully.',
          })
        } else {
          cb({
            ...result,
            isError: true,
            message: 'Bad request',
          })
        }
      }
    })
    .catch((err) => {
      if (cb) {
        cb({
          ...err,
          isError: true,
          message: 'Bad request',
        })
      }
    });
}

export function sendMessageSMS(options: Options) {
  const { paycode, phone, cb } = options;

  sendText(paycode, { to: phone })
    .then((result) => {
      if (cb) {
        if (result.hasOwnProperty('Sid') && result.Sid) {
          cb({
            ...result,
            isError: false,
            message: 'A text message was sent successfully.',
          })
        } else {
          cb({
            ...result,
            isError: true,
            message: 'Bad request',
          })
        }
      }
    })
    .catch((err) => {
      if (cb) {
        cb({
          ...err,
          isError: true,
          message: 'Bad request',
        })
      }
    });
}
